import React from "react"

import "./footer.css"
import Logo from '../../assets/svg/logo.svg';

const Footer = () => (
  <footer className="ft-Footer">
    <div className="ft-Footer_Inner lyt-Container">
      <div className="ft-Footer_Body">
        <div className="ft-Footer_Columns">
          <div className="ft-Footer_Column">
            <Logo />
          </div>

          <div className="ft-Footer_Column">
            <p>Unit 7, Arlington Business Park, Whittle Way, Stevenage, SG1 2BE</p>

            <p>CBW Limited © {new Date().getFullYear()}</p>
          </div>

          <div className="ft-Footer_Column">
            <p>Got a question for us?<br />
            Give us a call</p>

            <p><a className="ft-Footer_Link" href="tel:01438316400" target="_blank" rel="noopener noreferrer">01438 316 400</a></p>
          </div>

          <div className="ft-Footer_Column">
            <p>Or drop us an email</p>

            <p><a className="ft-Footer_Link" href="mailto:info@cbwlimited.com" target="_blank" rel="noopener noreferrer">info@cbwlimited.com</a></p>
          </div>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
